import { InfoIcon } from "./icons";
import StatusWrapper from "./status-wrapper";

function Content() {
  return (
    <p className="text-14/[1.71em] text-heather">
      This business has not yet been claimed by the owner or a representative.
      <br />
      <br />
      <a
        className="text-rose-red"
        href="https://link.morty.app/e/claim-your-business"
        rel="noopener noreferrer"
        target="_blank"
      >
        Claim this business
      </a>{" "}
      to respond to reviews, edit listings, and get access to your bookings.
      <br />
      <br />
      <a className="text-rose-red" href="/s/morty-for-business">
        Learn more
      </a>{" "}
      about the benefits of claiming your business and becoming a Morty Partner.
    </p>
  );
}

export interface UnclaimedProps extends React.ComponentProps<"svg"> {}

export default function Unclaimed(props: UnclaimedProps) {
  return (
    <StatusWrapper
      content={<Content />}
      popoverProps={{ side: "top" }}
      title="Unclaimed business"
    >
      <div className="flex gap-1 md:gap-1.5">
        <p className="font-medium text-14 text-heather">Unclaimed</p>
        <InfoIcon {...props} />
      </div>
    </StatusWrapper>
  );
}
